// extracted by mini-css-extract-plugin
export default {"wrapper":"CharacterWithBubble_wrapper__+riPT","bubble":"CharacterWithBubble_bubble__6wtra","area":"CharacterWithBubble_area__Q9gAu","image":"CharacterWithBubble_image__Hdp2x"};